import { post } from "./utils";

// 医院信息获取 
// export const getHospitalDetail = (params?: any) => 
//   post("NHPFCoreHInfo_getHospitalDetailById", params, '', 'jd_nethp_patient_h5');

// 医院信息获取(new)
export const getHospitalDetail = (params?: any) => 
  post("seo_reGenHospitalIntro", params, '', 'jd_nethp_patient_h5');

// 医院信息获取 
// export const getDoctorDepartment = (params?: any) => 
// post("NHPFCoreDoctorList_getDoctorFilterBar", params, '', 'jd_nethp_patient_h5');

// 医院信息获取(new)
export const getDoctorDepartment = (params?: any) => 
  post("seo_reGenDoctorFilterBar", params, '', 'jd_nethp_patient_h5');

// 医院获取评价列表 https://joyspace.jd.com/pages/H8417y0K5ltUsJ3qunON
export const getEvaluationsByHospital = (params?: any) => 
post("BNHFGetEvaluationsByHospital", params, '');

// 医院信息获取 
export const queryDoctorList = (params?: any) => 
post("NHPFCoreDoctorList_queryDoctorList", params, '', 'jd_nethp_patient_h5');

// 医院信息获取 
export const querySeoDoctorList = (params?: any) => 
post("NHPFCoreDoctorList_querySeoDoctorList", params, '', 'jd_nethp_patient_h5');

// 推荐文章列表（替换recommendContentArticle428）
export const queryRecommendArticles = (params?: any) => 
  post("jdh_seo_c_queryRecommendArticles", params, '', 'jd_nethp_patient_h5');
  
// 推荐问诊记录列表（替换 recommendContentDiag298 ）（替换 recommendContentQa435 ）
export const recommendContentQaGW = (params?: any) => 
  post("jdh_recommendContentQaGW", params, '', 'jd_nethp_patient_h5');
